module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_1_5rule.b2411b0b.jpg";